import React from "react";
import CardBasic from "../CardBasic";
import _ from "lodash";

export default function CardUser({
  i,
  data,
  enActionEdit,
  enActionDelete,
  editFunction,
  deleteFunction,
  isDisable,
}) {
  return (
    <CardBasic
      key={data.id}
      i={data.id}
      title={`${data?.profile?.firstName} ${data?.profile?.lastName}`}
      isDisable={isDisable}
      enActionDelete={enActionDelete}
      enActionEdit={enActionEdit}
      editFunction={editFunction}
      deleteFunction={deleteFunction}
      data={data}
    >
      <div className="cursor-pointer px-3 py-3 hover:bg-slate-50">
        <div className="space-y-2">
          <div className="flex justify-between text-xs">
            <p className="text-monochrome-300">Nomor WhatsApp</p>
            <p className="text-monochrome-400">+{data?.profile?.phone}</p>
          </div>
          <div className="flex justify-between text-xs">
            <p className="text-monochrome-300">Email</p>
            <p className="text-monochrome-400">
              {data.identifier
                ? !data.identifier.startsWith("62")
                  ? data.identifier
                  : "-"
                : "-"}
            </p>
          </div>
          <div className="flex justify-between text-xs">
            <p className="text-monochrome-300">Nama Akun</p>
            <p className="text-monochrome-400">
              {data?.outlet?.name
                ? data?.outlet?.name
                : _.first(data?.userOutlet)?.outlet?.name}
            </p>
          </div>
          <div className="flex justify-between text-xs">
            <p className="text-monochrome-300">Role</p>
            <p className="text-monochrome-400">
              {data?.role[0]?.userRole?.roleName}
            </p>
          </div>
        </div>
      </div>
    </CardBasic>
  );
}
